import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { useSelector } from 'react-redux';

import Message from 'components/Message';
import LINKS from 'constants/links';
import { bem } from 'helpers/class-name';
import Segment from 'helpers/segment';
import { selectActiveVenue } from 'selectors/general';
import { getPeakTimeMessage } from './SmartTools.helpers';

import './PeakTimeDefinition.scss';

export const messages = defineMessages({
  peakTimeUSCA: {
    id: 'manage.smart-tools.peak-definition-us-ca',
    defaultMessage:
      '<strong>Peak times:</strong> Monday to Friday from 6:00-9:59 AM and 5:00-6:59 PM, and Saturday and Sunday from 8:00-10:59 AM in the local time zone. <a>Learn more</a>',
  },
  peakTimeNonUSCA: {
    id: 'manage.smart-tools.peak-definition-non-us-ca',
    defaultMessage:
      '<strong>Peak times:</strong> Monday to Friday from 6:00-9:59 AM, 12:00-12:59 PM, and 5:00-7:59 PM, and Saturday and Sunday from 8:00-10:59 AM in the local time zone. <a>Learn more</a>',
  },
  offPeakTime: {
    id: 'manage.smart-tools.off-peak-definition',
    defaultMessage:
      '<strong>Off-peak times:</strong> All classes scheduled to start at any time other than Peak times. <a>Learn more</a>',
  },
});

const { block, element } = bem('peak-time-definition');

const PeakTimeDefinition = ({ countryCode = 'USA' }) => {
  const peakMessage = getPeakTimeMessage(countryCode, messages);

  const venueData = useSelector(selectActiveVenue);
  const { venueId } = venueData;

  const handleLearnMore = () => {
    Segment.event('Peak Off-peak Learn More', {
      venue_id: venueId,
    });
  };

  return (
    <div className={block()}>
      <Message
        as="div"
        className={element('peak-time-message')}
        message={peakMessage}
        values={{
          strong: text => <strong>{text}</strong>,
          a: text => (
            <a href={LINKS.termsAdditionalDefinitions.href} target="_blank" rel="noopener noreferrer">
              {text}
            </a>
          ),
        }}
      />
      <Message
        as="div"
        className={element('off-peak-time-message')}
        message={messages.offPeakTime}
        onClick={handleLearnMore}
        values={{
          strong: text => <strong>{text}</strong>,
          a: text => (
            <a href={LINKS.termsAdditionalDefinitions.href} target="_blank" rel="noopener noreferrer">
              {text}
            </a>
          ),
        }}
      />
    </div>
  );
};

PeakTimeDefinition.propTypes = {
  countryCode: PropTypes.string,
};

export default PeakTimeDefinition;
